






















































































































































import {
  apiOrderWriteOffGetImgSnCode,
  apiOrderWriteOffPreWriteOffInfo,
  ApiOrderWriteOffPreWriteOffInfoResponse,
  apiOrderWriteOffWriteOff,
  apiOrderWriteOffWriteOffDetail,
  ApiOrderWriteOffWriteOffDetailResponse,
} from '@/api'
import { apiSaleAfterStandardEcommerceSaleAfterUploadPic } from '@/api'
import { asRequiredDeep, wait } from 'vtils'
import { base64ToBlob } from '@dcb/utils'
import { BookComponents } from '../components'
import { computed, ref, watch } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import {
  defineClassComponent,
  useApiPlus,
  useLocalStorage,
  useQuery,
  useSet,
} from '@/hooks'
import { FileData } from 'yapi-to-typescript'
import { redirectTo } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '确认核销',
        }))

        watch(
          () => this.pageData.value,
          () => {
            if (
              this.pageData.value?.code?.length === 1 &&
              !this.selectedCoupons.value.length
            ) {
              this.selectedCouponSet.add(this.pageData.value.code[0])
            }
          },
          { immediate: true },
        )
      }

      query = useQuery<{
        code: string
        orderNo: string
      }>()

      apiData = useApiPlus(
        {
          pageData: () =>
            (this.query.code
              ? apiOrderWriteOffWriteOffDetail({
                  code: this.query.code,
                }).then<
                  ApiOrderWriteOffWriteOffDetailResponse &
                    ApiOrderWriteOffPreWriteOffInfoResponse
                >(
                  res =>
                    ({
                      ...res,
                      code: res.code ? [res.code] : [],
                    } as any),
                )
              : apiOrderWriteOffPreWriteOffInfo({
                  orderNo: this.query.orderNo,
                }).then<
                  ApiOrderWriteOffWriteOffDetailResponse &
                    ApiOrderWriteOffPreWriteOffInfoResponse
                >(
                  res =>
                    ({
                      ...res,
                      code: res.codeList,
                    } as any),
                )
            )
              .then(asRequiredDeep)
              .then(res => {
                if (res.hasPeri === false) {
                  throw res.errorMsg
                }
                this.selectedStoreData.value = res.writeOffStoreList.map(
                  item => ({
                    label: item.name,
                    value: item.id,
                  }),
                )
                this.selectedStore.value =
                  res.writeOffStoreList.find(
                    item => item.id === this.selectedStore.value,
                  )?.id || res.writeOffStoreList[0].id
                return res
              }),
        },
        {
          onError: (err: any) =>
            wait(1500).then(() => {
              redirectTo('BookVerifyResult', {
                success: false,
                message: typeof err === 'string' ? err : '',
              })
            }),
        },
      )

      form = ref({
        orderSnNum: '',
        writeOffImage: '',
      })

      codeList = ref([])

      pageData = computed(() => this.apiData.data.pageData)

      selectedCouponSet = useSet<string>([])

      selectedCoupons = computed(this.selectedCouponSet.toArray)

      selectedStoreData = ref<any[]>([])

      selectedStore = useLocalStorage('verify_confirm_store', '')

      handleClickCode = (item: { text: string }) => {
        this.form.value.orderSnNum = item.text
      }

      handleClickUpload = () => {
        submit(async $ => {
          // 经典选择模式
          const { images } = await dcb.chooseImage({
            mode: 'classical',
            count: 1,
          })

          const dataUrl = `data:image/jpeg;base64,${images[0]}`
          const blob = base64ToBlob(dataUrl)
          const file = new File([blob], `${new Date().getTime()}.png`, {
            type: blob.type,
          })

          try {
            $.start('上传中...')
            const data = await apiOrderWriteOffGetImgSnCode(
              {
                // 上传 file.file
                file: new FileData(file),
              },
              {
                timeout: 100000,
              },
            )

            const codesResult = data.codesResult || []

            this.codeList.value = codesResult.map(item => {
              return {
                text: item.text?.replace(/\[|\]/g, '').replace(/"/g, ''),
              }
            }) as []

            const { url } =
              (await apiSaleAfterStandardEcommerceSaleAfterUploadPic(
                {
                  // 上传 file.file
                  file: new FileData(file),
                },
                {
                  timeout: 100000,
                },
              )) as any
            this.form.value.writeOffImage = url
          } catch {
            return $.fail('上传失败')
          }
        })
      }
      handleVerifyConfirmClick = () => {
        submit(async $ => {
          if (!this.selectedCoupons.value.length) {
            return $.fail('请选择要核销的券码')
          }
          if (!this.selectedStore.value) {
            return $.fail('请选择核销店铺')
          }

          if (this.pageData.value.needPutSnCode) {
            if (!this.form.value.writeOffImage) {
              return $.fail('请上传SN码照片')
            }
            if (!this.form.value.orderSnNum) {
              return $.fail('请填写SN码')
            }
          }

          $.start('核销中...')
          try {
            await apiOrderWriteOffWriteOff({
              code: this.selectedCoupons.value,
              storeId: this.selectedStore.value,
              ...this.form.value,
            })
            redirectTo('BookVerifyResult', {
              success: true,
            })
          } catch {
            redirectTo('BookVerifyResult', {
              success: false,
            })
          }
        })
      }
    },
)
